import styles from '../../../Settings.module.scss';
import Typography from 'components/Typography/Typography';
import DeleteModal from 'components/DeleteModal';
import {Integration} from 'types/integration';
import {GoogleDriveIcon, ShopifyBrandIcon} from '../../icons';
import classNames from 'classnames';
import {INTEGRATION_OPTIONS_LABELS} from 'constants/integration-options';
type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  onDelete: () => void;
  integration: Integration;
  isDeleting: boolean;
};

function DeleteIntegrationModal({
  isOpen,
  onRequestClose,
  onDelete,
  integration,
  isDeleting,
}: Props) {
  return (
    <DeleteModal
      text="Are you sure you want to disconnect this integration?"
      openModal={isOpen}
      setOpenModal={onRequestClose}
      onDelete={onDelete}
      loading={isDeleting}
      confirmText={isDeleting ? 'Disconnecting...' : 'Disconnect'}
      component={
        <div className={styles.deleteInfoRow}>
          <div className={styles.mt15}>
            <Typography
              className={classNames(styles.fs20, styles.capital)}
              variant="p"
            >
              {INTEGRATION_OPTIONS_LABELS[integration.integration_type]}
            </Typography>
            <Typography
              className={classNames(styles.fs18, styles.capital, styles.m20)}
              variant="p"
            >
              Company Name: {integration.company_name}
            </Typography>
          </div>
          {integration.integration_type === 'shopify' && (
            <ShopifyBrandIcon width={100} height={100} />
          )}
          {integration.integration_type === 'google_drive' && (
            <GoogleDriveIcon width={100} height={100} />
          )}
        </div>
      }
    />
  );
}
export default DeleteIntegrationModal;
